// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoCard_root__17G38","header":"InfoCard_header__s589y","title":"InfoCard_title__3HGdC","infoTitle":"InfoCard_infoTitle__2Pg4J"};